import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import constants from '../ndbk-constants'
import PermissionsManager from './PermissionsManager'
import Utils from './Utils'

export default class NodebookSettings extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title: this.props.nodebookInfo.title,
            description: this.props.nodebookInfo.description,
            avatar: this.props.nodebookInfo.avatar
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            title: nextProps.nodebookInfo.title,
            description: nextProps.nodebookInfo.description,
            avatar: nextProps.nodebookInfo.avatar
        })
    }

    render() {

        var _disabled = !(this.props.nodebookInfo.permissions && this.props.authLevel[this.props.nodebookInfo.permissions] > 5)

        return (
            <div className="details-flex">
                <label className={"avatarpicker" + (_disabled ? ' disabled' : '')}>
                    <div className="cover" style={{ backgroundImage: `url('${this.state.avatar}')` }}></div>
                    {
                        (!_disabled)
                            ? <input type="file" multiple={false} accept="image/*" onChange={(e) => this.props.onFileInput(e.target.files)} />
                            : null
                    }
                </label>
                <div className="details">
                    {
                        // (this.props.auth.user.isGuest)
                        //     ? null
                        //     : (
                        //         <div style={{position: 'absolute', top: '8px', right: '8px'}}>
                        //             {/* (UN)SUBSCRIBE */}
                        //             <span
                        //                 className={"nicebtn leftround nomargin" + (this.props.nodebookInfo.isFollowing?' marked':'')}
                        //                 onClick={this.props.nodebookInfo.isFollowing?this.props.unsubscribeNodebook:this.props.subscribeNodebook}
                        //                 title={this.props.nodebookInfo.isFollowing?"Click to unfollow":"Click to follow"}
                        //             >
                        //                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                        //                     <path d="M1.5 19c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        //                     <path d="M3.5 10c-0.104 0-0.21-0.033-0.3-0.1-0.221-0.166-0.266-0.479-0.1-0.7 0.067-0.090 1.676-2.2 3.9-2.2 1.694 0 2.813 0.599 3.801 1.127 0.875 0.468 1.631 0.873 2.699 0.873 2.192 0 3.758-2.080 4.65-3.718-0.698 0.397-1.59 0.718-2.65 0.718-2.207 0-3.347-1.14-4.354-2.146-0.995-0.995-1.854-1.854-3.646-1.854-2.224 0-3.587 1.782-3.6 1.8-0.166 0.221-0.479 0.266-0.7 0.1s-0.266-0.479-0.1-0.7c0.067-0.090 1.681-2.2 4.4-2.2 2.207 0 3.347 1.14 4.354 2.146 0.995 0.995 1.854 1.854 3.646 1.854 2.224 0 3.587-1.782 3.6-1.8 0.147-0.196 0.415-0.257 0.632-0.143s0.32 0.368 0.242 0.601c-0.021 0.064-0.533 1.581-1.558 3.119-0.612 0.918-1.282 1.653-1.991 2.185-0.918 0.688-1.902 1.037-2.925 1.037-1.318 0-2.26-0.504-3.171-0.991-0.97-0.519-1.886-1.009-3.329-1.009-1.73 0-3.087 1.782-3.1 1.8-0.098 0.131-0.248 0.2-0.4 0.2z"></path>
                        //                 </svg> Follow
                        //             </span>
                        //             {/* (UN)LIKE */}
                        //             <span
                        //                 className={"nicebtn rightround nomargin" + (this.props.nodebookInfo.isLiked?' marked':'')}
                        //                 onClick={this.props.nodebookInfo.isLiked?this.props.unlikeNodebook:this.props.likeNodebook}
                        //                 title={this.props.nodebookInfo.isLiked?"Click to unlike":"Click to like"}
                        //             >
                        //                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                        //                     <path d="M18.916 11.208c0.443-0.511 0.695-1.355 0.695-2.159 0-0.531-0.115-0.996-0.333-1.345-0.284-0.454-0.738-0.704-1.278-0.704h-2.618c1.425-2.591 1.785-4.543 1.070-5.807-0.499-0.881-1.413-1.193-2.045-1.193-0.25 0-0.462 0.185-0.495 0.433-0.179 1.319-1.188 2.893-2.768 4.318-1.514 1.365-3.374 2.456-5.286 3.11-0.241-0.508-0.758-0.86-1.356-0.86h-3c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h3c0.634 0 1.176-0.395 1.396-0.952 1.961 0.246 2.699 0.64 3.414 1.022 0.895 0.478 1.739 0.93 4.503 0.93 0.72 0 1.398-0.188 1.91-0.529 0.5-0.333 0.82-0.801 0.926-1.343 0.399-0.162 0.753-0.536 1.024-1.092 0.264-0.541 0.435-1.232 0.435-1.761 0-0.099-0.006-0.19-0.017-0.274 0.253-0.186 0.48-0.473 0.667-0.851 0.27-0.545 0.432-1.228 0.432-1.826 0-0.424-0.079-0.777-0.234-1.051-0.013-0.022-0.026-0.044-0.039-0.065zM4.5 18h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v8.999c0 0 0 0.001 0 0.001-0 0.276-0.224 0.5-0.5 0.5zM18.339 10.274c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.618-0.865-3.781-1.134v-8.187c2.101-0.689 4.152-1.877 5.812-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.070 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z"></path>
                        //                 </svg> Like
                        //             </span>
                        //         </div>
                        //     )
                    }
                    <input
                        disabled={_disabled}
                        title="Nodebook title"
                        type="text"
                        className="maininfo"
                        placeholder="Title..."
                        value={this.state.title}
                        spellCheck="false"
                        maxLength={110}
                        onChange={e => {
                            this.props.updateNodebook({ title: e.target.value })
                        }}
                    />

                    <small>
                        <Link tabIndex="-1" to={`/user/${this.props.nodebookInfo.username}`}>{this.props.nodebookInfo.username}</Link> &middot; {Utils.parseTime(new Date(this.props.nodebookInfo.date_created), 'M D, Y')}
                        <div
                            title={_disabled ? "Nodebook visibility" : "Click to toggle visibility"}
                            className={`visibility-${this.props.nodebookInfo.visibility} ${_disabled ? 'disabled' : ''}`}
                            onClick={() => {
                                if (!_disabled) {
                                    this.props.toggleVisibility()
                                }
                            }}
                        >{this.props.nodebookInfo.visibility}</div>
                        {/*<div title={`You have ${this.props.nodebookInfo.permissions} privileges on this nodebook`} className="privileges disabled">{this.props.nodebookInfo.permissions}</div>*/}
                        <br />
                        <span className="lightinfo">{this.props.nodesData.length} nodes &middot; {this.props.linksData.length} links</span>
                    </small>
                    <br /><br />
                    <textarea
                        disabled={_disabled}
                        className="maininfo"
                        title="Nodebook description"
                        placeholder="Description..."
                        value={this.state.description}
                        spellCheck="false"
                        onChange={e => {
                            this.props.updateNodebook({ description: e.target.value })
                        }}
                    />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NodebookSettings.js